import React from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "../Blog";
import { useBranch, Navigate } from "./useBranch";
import BlogArticleView from "./BlogArticleView";

// 店舗別ブログ詳細(/:region/blog/:postId)。
// 対象記事がその店舗(storeId === region)に属していない場合は
// 店舗のブログ一覧へリダイレクトする(他店舗の記事URLで開けないようにする)。
const RegionBlogPost = () => {
  const { postId } = useParams<{ postId: string }>();
  const state = useBranch();
  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;

  const post = blogPosts.find((p) => p.id === postId && p.storeId === branch.id);
  if (!post) return <Navigate to={`/${branch.id}/blog`} replace />;

  const canonical = `https://tht-group.co.jp/${branch.id}/blog/${post.id}`;
  const blogListUrl = `https://tht-group.co.jp/${branch.id}/blog`;
  const breadcrumbs = [
    { name: "TOP", item: `https://tht-group.co.jp/${branch.id}` },
    { name: `${branch.roomName}｜ブログ`, item: blogListUrl },
    { name: post.title, item: canonical },
  ];

  return (
    <BlogArticleView
      post={post}
      canonical={canonical}
      ogType="article"
      breadcrumbs={breadcrumbs}
      backHref={`/${branch.id}/blog`}
      backLabel={`${branch.roomName}のブログ一覧へ戻る`}
    />
  );
};

export default RegionBlogPost;
